import { render, staticRenderFns } from "./modal-disclaimer-price.vue?vue&type=template&id=0778fd82&scoped=true"
import script from "./modal-disclaimer-price.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-disclaimer-price.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./modal-disclaimer-price.vue?vue&type=style&index=0&id=0778fd82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778fd82",
  null
  
)

export default component.exports